import { useLocation } from "react-router"
import { ProtectedRoute } from "@/lib/auth/protected-route"
import { Roles } from "@/lib/team/roles"
import { QuickEstimateWizard } from "@/components/estimates/quick-estimate/wizard"
import { EstimatePrerequisiteGate } from "@/components/estimates/estimate-prerequisite-gate"

export default function QuickEstimatePage() {
  const location = useLocation()
  return (
    <ProtectedRoute
      allowedRoles={[
        Roles.ServiceAdvisor,
        Roles.Estimator,
        Roles.Director,
        Roles.GeneralManager,
        Roles.ServiceManager,
      ]}
    >
      <EstimatePrerequisiteGate>
        <QuickEstimateWizard key={location.key} />
      </EstimatePrerequisiteGate>
    </ProtectedRoute>
  )
}
